import React from 'react';
import { Link } from 'react-router-dom';
import RequestInvitation from './RequestInvitation';

/**
 * InvitationRequest Component
 * Wrapper for the RequestInvitation component
 */
const InvitationRequest = () => {
  return <RequestInvitation />;
};

export default InvitationRequest; 